import { CurrentUser } from "../models/current-user";
import { DailyMetrics, DashboardAdmin, DashboardClinic, UserStatus } from "../models/dashboard";
import { Department } from "../models/department";
import { Organization } from "../models/organization";
import { Service } from "../models/service";
import { ServiceConfiguration } from "../models/service-configuration";
import { Alert, BreathSession, SummaryPatient } from "../models/summary";
import { User, UserConsent } from "../models/user";
import { Work } from "../models/work";

export class Reset {

  static alert() : Alert {
    return {
        userId: '',
        name: '',
        timeStamp: new Date,
        type: 0,
        value: 0,
        isChecked: false,
        description: '',
        checkedAt: 0,
        checkedBy: '',
        checker: ''
    }
  }

  static breathSession() : BreathSession {
    return {
      userId: '',
      sessionId: '',
      name: '',
      timeStamp: new Date(),
      duration: 0,
      notes: '',
      exercisesCount: 0,
      hasReport: false
    }
  }

  static currentUser() : CurrentUser {
    return {
      id: '',
      name: 'Unlogged',
      familyName: '',
      email: '',
      roles: [],
      userName: '',
      organizations: [],
      consents: Reset.userConsent(),
      features: {
        addusers: false,
        afib: false,
        breath: false,
        ecgDisplay: false,
        gait: false,
        hrv: false,
        longreport: false,
        posture: false
      }
    };
  }

  static dailyMetrics(): DailyMetrics {
    return {
        date: new Date(),
        fcrValue: 0.0,
        fcmValue: 0.0,
        fcrDelta: -200.0,
        fcmDelta: -200.0,
        frrValue: 0.0,
        frmValue: 0.0,
        frrDelta: -200.0,
        frmDelta: -200.0,
        o2RValue: 0.0,
        o2MValue: 0.0,
        o2RDelta: -200.0,
        o2MDelta: -200.0,
        minutesTot: 0,
        minutesMov: 0,
        minutesRst: 0,
        stepsValue: 0,
        stepsDelta: -200.0
    }
  }

  static dashboardAdmin(): DashboardAdmin {
    return {
      organization: '',
      departments: 0,
      totalUsers:0,
      activeUsers: 0,
      superAdmin: 0,
      admin: 0,
      clinician: 0,
      patient: 0,
      research: 0,
      services: [],
      users: []
    }
  }

  static dashboardClinic(): DashboardClinic {
    return {
      patients: 0,
      active24: 0,
      active30: 0,
      monitor24: '',
      monitor30: '',
      alerts: 0,
      alerts30: 0,
      report24: 0,
      report30: 0,
      users: []
    }
  }
  
  static department(): Department {
    return {
      departmentId: 0,
      organizationId: 0,
      name: '',
      organization: '',
      updatedAt: new Date(),
      features: []
    };
  }

  static organization(): Organization {
    return {
      organizationId: 0,
      updatedAt: new Date(),
      name: ''
    }
  }

  static service(): Service {
    return {
      serviceId: 0,
      name: '',
      description: '',
      limit: 0,
      expirationMonths: 1,
      autoRenewal: false,
      updatedAt: new Date()
    };
  }

  static serviceConfiguration() : ServiceConfiguration {
    return {
      serviceId: 0,
      organizationId: 0,
      departmentId: 0,
      limit: 0,
      occurrencies: 0,
      isActive: false,
      expirationMonths: 1,
      expirationAt: new Date(0),
      autoRenewal: false,
      updatedAt: new Date(0)
    };
  }

  static summaryPatient(): SummaryPatient {
    return {
      id: '',
      name: '',
      logInfo: new Date(),
      roles: [],
      departments: [],
      alert: [],
      hasAlert: false,
      lastReport: new Date(),
      reportType: '',
      compliance: '',
      metrics: Reset.dailyMetrics(),
      fcGraphs: [],
      frGraphs: [],
      o2Graphs: [],
      alerts30: 0,
      reports24: 0,
      reports30: 0,
      lastMeasure: 0
    }
  }

  static user(): User {
    return {
      userId: '',
      firstName: '',
      lastName: '',
      userName: '',
      isActive: true,
      updatedAt: new Date(),
      roles: [],
      organizations: [],
      consents: Reset.userConsent()
    };
  }

  static userConsent() : UserConsent {
    return {
      userId: '',
      gdprConsent: false,
      sanitaryConsent: false,
      tcConsent: false,
      emailConfirmed: false,
      updatedAt: new Date
    }
  }

  static userStatus() : UserStatus {
    return {
      id: '',
      name:'',
      logInfo: new Date(),
      roles: [],
      departments: [],
      alert: [],
      hasAlert: false,
      lastReport: new Date(),
      reportType: '',
      compliance: '',
      metrics: Reset.dailyMetrics()
    }
  }

  static work(): Work {
    return {
      id: '',
      name: '',
      all: false,
      organizationId: 0,
      organization: '',
      departmentIds: [],
      departments: [],
      isEnabled: false,
      deltaDays: 0,
      deltaTime: '00:00:00',
      last: new Date(),
      next: new Date(),
    };
  }
}
